import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Label} from '@/components/ui/label/Label'
import {useTranslation} from '@/translations/i18n'
import {patientTaxCodeTypeToLabel} from '@/features/patients/utils'
import {FC} from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import {InputTaxCode} from '@/components/ui/form-atoms/FormAtoms'
import {PatientPersonalDataFormValidationSchema} from '@/features/patients/types'

interface PatientTaxCodeFieldProps {
    label: string
}

export const PatientTaxCodeField: FC<PatientTaxCodeFieldProps> = ({label}) => {
    const {t} = useTranslation()
    const form = useFormContext<Pick<PatientPersonalDataFormValidationSchema, 'taxCodeType' | 'taxCode'>>()

    return (
        <Flexbox direction="column" gap={1.5} fullWidth>
            <Label>{label}</Label>
            <Flexbox fullWidth gap={2}>
                <Controller
                    control={form.control}
                    name="taxCodeType"
                    render={({field}) => (
                        <InputSelect
                            placeholder={t('commons:tax_code_type')}
                            errorMessage={form.formState.errors.taxCodeType?.message ?? ''}
                            sameWidth
                            optionsMap={patientTaxCodeTypeToLabel}
                            value={field.value}
                            onChange={field.onChange}
                        />
                    )}
                />
                <InputTaxCode
                    type="text"
                    placeholder={'STP1234567'}
                    errorMessage={form.formState.errors.taxCode?.message ?? ''}
                    {...form.register('taxCode')}
                />
            </Flexbox>
        </Flexbox>
    )
}
